import axios from 'axios'
import Vue from 'vue'
import i18n from '../../../../i18n';

const state = {
    token: localStorage.getItem('user-token') || '',
    loading: true,
    fonts: [],
    font: {},
    message: {},
}

const getters = {
    getAllFonts(state){
        return state.fonts;
    },
    getFont(state){
        return state.font;
    },
    getFontResponseMsg(state){
        return state.message;
    },
}

const mutations = {
    updateAllFonts(state, fonts) {
        state.fonts = fonts
     },
     updateFonts(state, font) {
        state.font = font
     },
     updateFontsResponseMsg(state, message) {
        state.message = message
     },
}

const actions = {
    ['LOAD_ALL_FONTS']: ({commit}) => {
        return new Promise((resolve) => { 
        axios.get('product-font',
        {}).then(resp => {
            if(!resp.data.error){
                commit('updateAllFonts', resp.data.data)
            } else {
              console.log('Error')
            }
            resolve(resp)
            })
        })
    },

    ['CREATE_FONT']: ({commit}, data) => {
        return new Promise((resolve) => { 
        axios.post(`product-font`, {  
            name: data.name,
            price: data.price
        }).then(resp => {
            if(!resp.data.error){
                commit('updateFontsResponseMsg', resp.data)
                Vue.toasted.show(i18n.tc(`successfully`),{
                    theme: 'outline',
                    singleton: true,
                    position:'top-center',
                    action :
                    {
                        text : i18n.tc(`ok`),
                        onClick : (e, toastObject) => {
                            toastObject.goAway(0);
                        }  
                    }
                });
            } else {
              console.log(resp.data.error)
            }
            resolve(resp)
            })
        })
      },

      ['GET_FONT']: ({commit}, id) => {
        return new Promise((resolve) => { 
        axios.get(`product-font/${id}`, 
        {}).then(resp => {
            if(!resp.data.error){
                commit('updateFonts', resp.data.data)
            } else {
              console.log(resp.data.error)
            }
            resolve(resp)
            })
        })
      },

      ['UPDATE_FONT']: ({commit}, data) => {
        return new Promise((resolve) => { 
        axios.put(`product-font/${data.id}`, {
            name: data.name,
            price: data.price
        }).then(resp => {
            if(!resp.data.error){
                commit('updateFontsResponseMsg', resp.data.data)
                Vue.toasted.show(i18n.tc(`successfully`),{
                    theme: 'outline',
                    singleton: true,
                    position:'top-center',
                    action :
                    {
                        text : i18n.tc(`ok`),
                        onClick : (e, toastObject) => {
                            toastObject.goAway(0);
                        }  
                    }
                });
            } else {
              console.log(resp.data.error)
            }
            resolve(resp)
            })
        })
      },

      ['DELETE_FONT']: ({commit}, id) => {
        return new Promise((resolve) => { 
        axios.delete(`product-font/${id}`, 
        {}).then(resp => {
            if(!resp.data.error){
                commit('updateFontsResponseMsg', resp.data.data)
                console.log(resp.data)
                Vue.toasted.show(i18n.tc(`successfully`),{
                    theme: 'outline',
                    singleton: true,
                    position:'top-center',
                    action :
                    {
                        text : i18n.tc(`ok`),
                        onClick : (e, toastObject) => {
                            toastObject.goAway(0);
                        }  
                    }
                });
            } else {
              console.log(resp.data.error)
            }
            resolve(resp)
            })
        })
      },

}

export default {
    state,
    getters,
    mutations,
    actions
}